import { Row, Col } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { ButtonEditSummaryItem } from './editSummaryComponents/ButtonEditSummaryItem';
import { ChildItemsContainer, ColumnRadio, RadioSummary, TitleSummary } from '../../style';

export const RadioComponent = ({ field, parents = [], renderFields, onEdit, readOnly, reloadData }) => {
  return (
    <Row>
      <br />
      <TitleSummary style={{ fontSize: '15px' }}>{field.label}</TitleSummary>
      {onEdit != null ? <ButtonEditSummaryItem onClick={onEdit} /> : null}

      <ColumnRadio xs={24} md={24}>
        {field.value?.map((item) => {
          return (
            <>
              <Col xs={24} md={24}>
                <RadioSummary defaultChecked={item.value} key={item.idInput} disabled checked={item.value}>
                  <p style={{ color: 'black' }}>{item.label}</p>
                </RadioSummary>
              </Col>
              {item?.valueConditional?.length > 0 ? (
                <ChildItemsContainer>
                  {renderFields({
                    fields: item.valueConditional,
                    parents: [...parents, { idInput: field.idInput }, { idInput: item.idInput }],
                    renderFields,
                    readOnly,
                    reloadData,
                  })}
                </ChildItemsContainer>
              ) : null}
            </>
          );
        })}
      </ColumnRadio>
    </Row>
  );
};

RadioComponent.propTypes = {
  field: PropTypes.object.isRequired,
  parents: PropTypes.array,
  renderFields: PropTypes.func,
  onEdit: PropTypes.func,
  reloadData: PropTypes.func,
  readOnly: PropTypes.bool,
};
